module.exports = __webpack_public_path__ + "static/FDR-ppc_hero-be264f5b75f00ea495ab911749944343.jpeg";